// format.ts -- shared display helpers.
export function formatSize(bytes) {
    if (!Number.isFinite(bytes) || bytes < 0)
        return '\u2014';
    if (bytes < 1024)
        return `${bytes} B`;
    if (bytes < 1024 * 1024)
        return `${(bytes / 1024).toFixed(1)} KB`;
    if (bytes < 1024 * 1024 * 1024)
        return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
    return `${(bytes / 1024 / 1024 / 1024).toFixed(2)} GB`;
}
export function formatDate(iso) {
    if (!iso)
        return '';
    try {
        const d = new Date(iso);
        return d.toLocaleString();
    }
    catch {
        return iso;
    }
}
export function formatRelative(iso) {
    if (!iso)
        return '';
    const now = Date.now();
    const t = new Date(iso).getTime();
    if (!Number.isFinite(t))
        return iso;
    const sec = Math.round((now - t) / 1000);
    if (sec < 60)
        return `${sec}s ago`;
    if (sec < 3600)
        return `${Math.round(sec / 60)}m ago`;
    if (sec < 86400)
        return `${Math.round(sec / 3600)}h ago`;
    return new Date(iso).toLocaleDateString();
}
